import React from 'react'
import { HISTORY_FIELDS, DATA_TYPE_EXAMPLES, LINK_EXAMPLE_DATA_TYPES } from './MiscRecordDetailUtils'

const MiscRecordDetailHistoryTab = ({
  historyConfig,
  isSelected,
  onHistoryBoxClick,
  selectedHistoryFieldName,
  onHistoryFieldClick,
}) => {
  const fields =
    historyConfig.Fields && historyConfig.Fields.length > 0
      ? [...historyConfig.Fields].sort((a, b) => a.SortOrder - b.SortOrder)
      : null

  return (
    <div className="misc-record-detail-history-tab">
      <div className={`misc-record-detail-card${historyConfig.IsEnabled && historyConfig.ShowChangedFromTo ? ' expanded' : ''}`}>
        <div
          className={`card-header${isSelected ? ' selected' : ''}`}
          role="button"
          tabIndex={0}
          onClick={onHistoryBoxClick}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onHistoryBoxClick() } }}
        >
          Filing History
        </div>
        {historyConfig.IsEnabled ? (
          <div className="card-fields-columns">
            <div className="card-fields">
              {fields
                ? fields.map((field) => (
                    <div
                      key={field.FieldName}
                      className={`history-field-row${field.FieldName === selectedHistoryFieldName ? ' selected' : ''}${!field.IsEnabled ? ' disabled' : ''}`}
                      role="button"
                      tabIndex={0}
                      onClick={() => onHistoryFieldClick(field)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onHistoryFieldClick(field) } }}
                    >
                      <span>{field.Label || field.FieldName}</span>
                      {DATA_TYPE_EXAMPLES[field.DataType] != null && (
                        <span className={`field-example${LINK_EXAMPLE_DATA_TYPES.has(field.DataType) ? ' link-example' : ''}`}>{DATA_TYPE_EXAMPLES[field.DataType]}</span>
                      )}
                    </div>
                  ))
                : HISTORY_FIELDS.map((fieldName) => (
                    <div key={fieldName} className="history-field-row">
                      {fieldName}
                    </div>
                  ))}
              {historyConfig.IsVoidable && (
                <div className="history-field-row readonly">
                  <span>Void</span>
                  <span className="field-example">(button)</span>
                </div>
              )}
              {historyConfig.AllowCorrespondenceDownloads && (
                <div className="history-field-row readonly">
                  <span>Correspondence Downloads</span>
                  <span className="field-example">(download links)</span>
                </div>
              )}
            </div>
            {historyConfig.ShowChangedFromTo && (
              <div className="changed-from-to-preview">
                <div className="changed-from-to-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Changed From</th>
                        <th>Changed To</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>John Smith</td>
                        <td>Jane Smith</td>
                      </tr>
                      <tr>
                        <td>IsActive</td>
                        <td>No</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="card-fields">
            <span className="not-enabled-message">Not Enabled</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default MiscRecordDetailHistoryTab
